import { render, staticRenderFns } from "./StoreInfo.vue?vue&type=template&id=a369fd86&scoped=true"
import script from "./StoreInfo.vue?vue&type=script&lang=js"
export * from "./StoreInfo.vue?vue&type=script&lang=js"
import style0 from "./StoreInfo.vue?vue&type=style&index=0&id=a369fd86&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a369fd86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a369fd86')) {
      api.createRecord('a369fd86', component.options)
    } else {
      api.reload('a369fd86', component.options)
    }
    module.hot.accept("./StoreInfo.vue?vue&type=template&id=a369fd86&scoped=true", function () {
      api.rerender('a369fd86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/store/StoreInfo.vue"
export default component.exports